// Il n'y a plus de plafond d'équipe : la facturation se fait au siège, alors refuser une
// sixième personne à quelqu'un qui veut payer pour elle n'a plus de sens. L'API renvoie
// encore `maxTeamSize`, mais à `null` ; l'écran ne le lit plus.
var initialState = {
  invitations: [],
  teamMembers: [],
  isOwner: true,
  teamSize: 1,
};

var invitation = function (state, action) {
  if (state === undefined) state = initialState;

  switch (action.type) {
    case 'SET_TEAM_DATA':
      return {
        invitations: action.data.invitations || [],
        teamMembers: action.data.teamMembers || [],
        isOwner: action.data.isOwner !== undefined ? action.data.isOwner : true,
        teamSize: action.data.teamSize || 1,
      };
    case 'SET_INVITATIONS':
      return Object.assign({}, state, { invitations: action.invitations });
    // Le compte suit la liste. Retirer quelqu'un ne renvoie que `teamMembers` : garder
    // l'ancien `teamSize` laissait l'en-tête annoncer « 3 membres » au-dessus de deux
    // lignes, jusqu'au prochain rechargement. La liste contient TOUT LE MONDE depuis
    // l'étape 4, administrateurs compris, donc sa longueur EST la taille de l'équipe.
    case 'SET_TEAM_MEMBERS':
      return Object.assign({}, state, {
        teamMembers: action.teamMembers,
        teamSize: action.teamMembers.length || 1,
      });
    default:
      return state;
  }
};

export default invitation;
